import './EnterAddressField.css'
import clear from "../../imgs/clear.png";
import {FocusEventHandler, useState} from "react";
import SelectOnMapButton from "./SelectOnMapButton";

interface IEnterAddressFieldProps {
    value: string,
    onSelectOnMap: () => void
    showSelectOnMapButton: boolean
    onChange: (text: string) => void
    onFocus: FocusEventHandler<HTMLElement>
    onBlur: FocusEventHandler<HTMLElement>
    onClear: () => void
}

export default function EnterAddressField(props: IEnterAddressFieldProps) {
    return <>
        <input
            defaultValue={props.value}
            value={props.value}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            className="Enter_address_field__input"
            onChange={(e) => {
                let newValue = e.target.value
                props.onChange(newValue)
            }}
        />
        {
            (props.value.length > 0) &&
            <button className="Enter_address_field__clear_button"
                    onFocus={props.onFocus}
                    onBlur={props.onBlur}
                    onClick={(e) => props.onClear()}
                    onMouseDown={(e) => e.preventDefault()}>
                <img src={clear} className="Enter_address_field__clear_button_image"/>
            </button>
        }
        {
            props.showSelectOnMapButton &&
            <div className="Enter_address_field__select_on_map_button">
                <SelectOnMapButton onClick={props.onSelectOnMap}/>
            </div>
        }
    </>;
}